"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tower Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.154
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TowerApi = exports.TowerApiFactory = exports.TowerApiFp = exports.TowerApiAxiosParamCreator = exports.NetworkDeviceContextApi = exports.NetworkDeviceContextApiFactory = exports.NetworkDeviceContextApiFp = exports.NetworkDeviceContextApiAxiosParamCreator = exports.LoraCoverageApi = exports.LoraCoverageApiFactory = exports.LoraCoverageApiFp = exports.LoraCoverageApiAxiosParamCreator = exports.HealthCheckApi = exports.HealthCheckApiFactory = exports.HealthCheckApiFp = exports.HealthCheckApiAxiosParamCreator = exports.FarmClusterApi = exports.FarmClusterApiFactory = exports.FarmClusterApiFp = exports.FarmClusterApiAxiosParamCreator = exports.DeviceStatusApi = exports.DeviceStatusApiFactory = exports.DeviceStatusApiFp = exports.DeviceStatusApiAxiosParamCreator = exports.DeviceSettingsApi = exports.DeviceSettingsApiFactory = exports.DeviceSettingsApiFp = exports.DeviceSettingsApiAxiosParamCreator = exports.DeviceContextApi = exports.DeviceContextApiFactory = exports.DeviceContextApiFp = exports.DeviceContextApiAxiosParamCreator = exports.ITowerMetricFormatEnum = exports.IEventTypeEnum = exports.IDevicePortEnum = exports.IDeviceControlMethodEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.IDeviceControlMethodEnum = {
    PKT_FWD: 'PKT_FWD',
    PORT_TOGGLE: 'PORT_TOGGLE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.IDevicePortEnum = {
    _1: 'PORT_1',
    _2: 'PORT_2',
    _3: 'PORT_3',
    _4: 'PORT_4',
    DC: 'PORT_DC'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.IEventTypeEnum = {
    CREATED: 'CREATED',
    UPDATED: 'UPDATED',
    DELETED: 'DELETED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ITowerMetricFormatEnum = {
    JSON: 'JSON',
    PROTOBUF: 'PROTOBUF'
};
/**
 * DeviceContextApi - axios parameter creator
 * @export
 */
var DeviceContextApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create device context.
         * @param {ICreateDeviceContextRequestDTO} [iCreateDeviceContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeviceContext: function (iCreateDeviceContextRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/tower/device-context";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateDeviceContextRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete device context by ID and farm ID.
         * @param {string} id Unique ID of device.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeviceContextByIDAndFarmID: function (id, farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteDeviceContextByIDAndFarmID', 'id', id);
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteDeviceContextByIDAndFarmID', 'farmId', farmId);
                    localVarPath = "/tower/device-context/{id}/{farmId}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all device contexts.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeviceContexts: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/tower/device-context";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all device contexts by farm id.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeviceContextsByFarmID: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllDeviceContextsByFarmID', 'farmId', farmId);
                    localVarPath = "/tower/device-context/farm/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all device contexts by ID.
         * @param {string} id Unique ID of device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeviceContextsByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getAllDeviceContextsByID', 'id', id);
                    localVarPath = "/tower/device-context/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all device contexts by shard id.
         * @param {string} shardId Unique ID of shard.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeviceContextsByShardID: function (shardId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'shardId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllDeviceContextsByShardID', 'shardId', shardId);
                    localVarPath = "/tower/device-context/shard/{shardId}"
                        .replace("{".concat("shardId", "}"), encodeURIComponent(String(shardId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all device contexts by tower id.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeviceContextsByTowerID: function (towerId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'towerId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllDeviceContextsByTowerID', 'towerId', towerId);
                    localVarPath = "/tower/device-context/tower/{towerId}"
                        .replace("{".concat("towerId", "}"), encodeURIComponent(String(towerId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get device context by ID and farm ID.
         * @param {string} id Unique ID of device.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceContextByIDAndFarmID: function (id, farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getDeviceContextByIDAndFarmID', 'id', id);
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('getDeviceContextByIDAndFarmID', 'farmId', farmId);
                    localVarPath = "/tower/device-context/{id}/{farmId}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update device context by ID and farm ID.
         * @param {string} id Unique ID of device.
         * @param {string} farmId Unique ID of farm.
         * @param {IUpdateDeviceContextRequestDTO} [iUpdateDeviceContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceContextByIDAndFarmID: function (id, farmId, iUpdateDeviceContextRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateDeviceContextByIDAndFarmID', 'id', id);
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('updateDeviceContextByIDAndFarmID', 'farmId', farmId);
                    localVarPath = "/tower/device-context/{id}/{farmId}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateDeviceContextRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DeviceContextApiAxiosParamCreator = DeviceContextApiAxiosParamCreator;
/**
 * DeviceContextApi - functional programming interface
 * @export
 */
var DeviceContextApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DeviceContextApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create device context.
         * @param {ICreateDeviceContextRequestDTO} [iCreateDeviceContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeviceContext: function (iCreateDeviceContextRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDeviceContext(iCreateDeviceContextRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete device context by ID and farm ID.
         * @param {string} id Unique ID of device.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeviceContextByIDAndFarmID: function (id, farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDeviceContextByIDAndFarmID(id, farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all device contexts.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeviceContexts: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllDeviceContexts(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all device contexts by farm id.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeviceContextsByFarmID: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllDeviceContextsByFarmID(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all device contexts by ID.
         * @param {string} id Unique ID of device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeviceContextsByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllDeviceContextsByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all device contexts by shard id.
         * @param {string} shardId Unique ID of shard.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeviceContextsByShardID: function (shardId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllDeviceContextsByShardID(shardId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all device contexts by tower id.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeviceContextsByTowerID: function (towerId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllDeviceContextsByTowerID(towerId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get device context by ID and farm ID.
         * @param {string} id Unique ID of device.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceContextByIDAndFarmID: function (id, farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDeviceContextByIDAndFarmID(id, farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update device context by ID and farm ID.
         * @param {string} id Unique ID of device.
         * @param {string} farmId Unique ID of farm.
         * @param {IUpdateDeviceContextRequestDTO} [iUpdateDeviceContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceContextByIDAndFarmID: function (id, farmId, iUpdateDeviceContextRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDeviceContextByIDAndFarmID(id, farmId, iUpdateDeviceContextRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DeviceContextApiFp = DeviceContextApiFp;
/**
 * DeviceContextApi - factory interface
 * @export
 */
var DeviceContextApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DeviceContextApiFp)(configuration);
    return {
        /**
         * Create device context.
         * @param {ICreateDeviceContextRequestDTO} [iCreateDeviceContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeviceContext: function (iCreateDeviceContextRequestDTO, options) {
            return localVarFp.createDeviceContext(iCreateDeviceContextRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete device context by ID and farm ID.
         * @param {string} id Unique ID of device.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeviceContextByIDAndFarmID: function (id, farmId, options) {
            return localVarFp.deleteDeviceContextByIDAndFarmID(id, farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all device contexts.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeviceContexts: function (options) {
            return localVarFp.getAllDeviceContexts(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all device contexts by farm id.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeviceContextsByFarmID: function (farmId, options) {
            return localVarFp.getAllDeviceContextsByFarmID(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all device contexts by ID.
         * @param {string} id Unique ID of device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeviceContextsByID: function (id, options) {
            return localVarFp.getAllDeviceContextsByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all device contexts by shard id.
         * @param {string} shardId Unique ID of shard.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeviceContextsByShardID: function (shardId, options) {
            return localVarFp.getAllDeviceContextsByShardID(shardId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all device contexts by tower id.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeviceContextsByTowerID: function (towerId, options) {
            return localVarFp.getAllDeviceContextsByTowerID(towerId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get device context by ID and farm ID.
         * @param {string} id Unique ID of device.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceContextByIDAndFarmID: function (id, farmId, options) {
            return localVarFp.getDeviceContextByIDAndFarmID(id, farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update device context by ID and farm ID.
         * @param {string} id Unique ID of device.
         * @param {string} farmId Unique ID of farm.
         * @param {IUpdateDeviceContextRequestDTO} [iUpdateDeviceContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceContextByIDAndFarmID: function (id, farmId, iUpdateDeviceContextRequestDTO, options) {
            return localVarFp.updateDeviceContextByIDAndFarmID(id, farmId, iUpdateDeviceContextRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DeviceContextApiFactory = DeviceContextApiFactory;
/**
 * DeviceContextApi - object-oriented interface
 * @export
 * @class DeviceContextApi
 * @extends {BaseAPI}
 */
var DeviceContextApi = /** @class */ (function (_super) {
    __extends(DeviceContextApi, _super);
    function DeviceContextApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create device context.
     * @param {ICreateDeviceContextRequestDTO} [iCreateDeviceContextRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceContextApi
     */
    DeviceContextApi.prototype.createDeviceContext = function (iCreateDeviceContextRequestDTO, options) {
        var _this = this;
        return (0, exports.DeviceContextApiFp)(this.configuration).createDeviceContext(iCreateDeviceContextRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete device context by ID and farm ID.
     * @param {string} id Unique ID of device.
     * @param {string} farmId Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceContextApi
     */
    DeviceContextApi.prototype.deleteDeviceContextByIDAndFarmID = function (id, farmId, options) {
        var _this = this;
        return (0, exports.DeviceContextApiFp)(this.configuration).deleteDeviceContextByIDAndFarmID(id, farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all device contexts.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceContextApi
     */
    DeviceContextApi.prototype.getAllDeviceContexts = function (options) {
        var _this = this;
        return (0, exports.DeviceContextApiFp)(this.configuration).getAllDeviceContexts(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all device contexts by farm id.
     * @param {string} farmId Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceContextApi
     */
    DeviceContextApi.prototype.getAllDeviceContextsByFarmID = function (farmId, options) {
        var _this = this;
        return (0, exports.DeviceContextApiFp)(this.configuration).getAllDeviceContextsByFarmID(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all device contexts by ID.
     * @param {string} id Unique ID of device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceContextApi
     */
    DeviceContextApi.prototype.getAllDeviceContextsByID = function (id, options) {
        var _this = this;
        return (0, exports.DeviceContextApiFp)(this.configuration).getAllDeviceContextsByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all device contexts by shard id.
     * @param {string} shardId Unique ID of shard.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceContextApi
     */
    DeviceContextApi.prototype.getAllDeviceContextsByShardID = function (shardId, options) {
        var _this = this;
        return (0, exports.DeviceContextApiFp)(this.configuration).getAllDeviceContextsByShardID(shardId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all device contexts by tower id.
     * @param {string} towerId Unique ID of tower.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceContextApi
     */
    DeviceContextApi.prototype.getAllDeviceContextsByTowerID = function (towerId, options) {
        var _this = this;
        return (0, exports.DeviceContextApiFp)(this.configuration).getAllDeviceContextsByTowerID(towerId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get device context by ID and farm ID.
     * @param {string} id Unique ID of device.
     * @param {string} farmId Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceContextApi
     */
    DeviceContextApi.prototype.getDeviceContextByIDAndFarmID = function (id, farmId, options) {
        var _this = this;
        return (0, exports.DeviceContextApiFp)(this.configuration).getDeviceContextByIDAndFarmID(id, farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update device context by ID and farm ID.
     * @param {string} id Unique ID of device.
     * @param {string} farmId Unique ID of farm.
     * @param {IUpdateDeviceContextRequestDTO} [iUpdateDeviceContextRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceContextApi
     */
    DeviceContextApi.prototype.updateDeviceContextByIDAndFarmID = function (id, farmId, iUpdateDeviceContextRequestDTO, options) {
        var _this = this;
        return (0, exports.DeviceContextApiFp)(this.configuration).updateDeviceContextByIDAndFarmID(id, farmId, iUpdateDeviceContextRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DeviceContextApi;
}(base_1.BaseAPI));
exports.DeviceContextApi = DeviceContextApi;
/**
 * DeviceSettingsApi - axios parameter creator
 * @export
 */
var DeviceSettingsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get device settings by ID.
         * @param {string} id Unique ID of device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceSettingsByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getDeviceSettingsByID', 'id', id);
                    localVarPath = "/tower/device-settings/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update device settings by ID.
         * @param {string} id Unique ID of device.
         * @param {IUpdateDeviceSettingsRequestDTO} [iUpdateDeviceSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceSettingsByID: function (id, iUpdateDeviceSettingsRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateDeviceSettingsByID', 'id', id);
                    localVarPath = "/tower/device-settings/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateDeviceSettingsRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DeviceSettingsApiAxiosParamCreator = DeviceSettingsApiAxiosParamCreator;
/**
 * DeviceSettingsApi - functional programming interface
 * @export
 */
var DeviceSettingsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DeviceSettingsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get device settings by ID.
         * @param {string} id Unique ID of device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceSettingsByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDeviceSettingsByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update device settings by ID.
         * @param {string} id Unique ID of device.
         * @param {IUpdateDeviceSettingsRequestDTO} [iUpdateDeviceSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceSettingsByID: function (id, iUpdateDeviceSettingsRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDeviceSettingsByID(id, iUpdateDeviceSettingsRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DeviceSettingsApiFp = DeviceSettingsApiFp;
/**
 * DeviceSettingsApi - factory interface
 * @export
 */
var DeviceSettingsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DeviceSettingsApiFp)(configuration);
    return {
        /**
         * Get device settings by ID.
         * @param {string} id Unique ID of device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceSettingsByID: function (id, options) {
            return localVarFp.getDeviceSettingsByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update device settings by ID.
         * @param {string} id Unique ID of device.
         * @param {IUpdateDeviceSettingsRequestDTO} [iUpdateDeviceSettingsRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceSettingsByID: function (id, iUpdateDeviceSettingsRequestDTO, options) {
            return localVarFp.updateDeviceSettingsByID(id, iUpdateDeviceSettingsRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DeviceSettingsApiFactory = DeviceSettingsApiFactory;
/**
 * DeviceSettingsApi - object-oriented interface
 * @export
 * @class DeviceSettingsApi
 * @extends {BaseAPI}
 */
var DeviceSettingsApi = /** @class */ (function (_super) {
    __extends(DeviceSettingsApi, _super);
    function DeviceSettingsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get device settings by ID.
     * @param {string} id Unique ID of device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceSettingsApi
     */
    DeviceSettingsApi.prototype.getDeviceSettingsByID = function (id, options) {
        var _this = this;
        return (0, exports.DeviceSettingsApiFp)(this.configuration).getDeviceSettingsByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update device settings by ID.
     * @param {string} id Unique ID of device.
     * @param {IUpdateDeviceSettingsRequestDTO} [iUpdateDeviceSettingsRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceSettingsApi
     */
    DeviceSettingsApi.prototype.updateDeviceSettingsByID = function (id, iUpdateDeviceSettingsRequestDTO, options) {
        var _this = this;
        return (0, exports.DeviceSettingsApiFp)(this.configuration).updateDeviceSettingsByID(id, iUpdateDeviceSettingsRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DeviceSettingsApi;
}(base_1.BaseAPI));
exports.DeviceSettingsApi = DeviceSettingsApi;
/**
 * DeviceStatusApi - axios parameter creator
 * @export
 */
var DeviceStatusApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get device status by ID.
         * @param {string} id Unique ID of device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceStatusByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getDeviceStatusByID', 'id', id);
                    localVarPath = "/tower/device-status/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Process incoming device check ins (create if does not exist).
         * @param {Array<IUpdateDeviceStatusRequestDTO>} [iUpdateDeviceStatusRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processDeviceCheckIns: function (iUpdateDeviceStatusRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/tower/device-status/check-in";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateDeviceStatusRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update device status by ID (create if does not exist).
         * @param {string} id Unique ID of device.
         * @param {IUpdateDeviceStatusRequestDTO} [iUpdateDeviceStatusRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceStatusByID: function (id, iUpdateDeviceStatusRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateDeviceStatusByID', 'id', id);
                    localVarPath = "/tower/device-status/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateDeviceStatusRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DeviceStatusApiAxiosParamCreator = DeviceStatusApiAxiosParamCreator;
/**
 * DeviceStatusApi - functional programming interface
 * @export
 */
var DeviceStatusApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DeviceStatusApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get device status by ID.
         * @param {string} id Unique ID of device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceStatusByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDeviceStatusByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Process incoming device check ins (create if does not exist).
         * @param {Array<IUpdateDeviceStatusRequestDTO>} [iUpdateDeviceStatusRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processDeviceCheckIns: function (iUpdateDeviceStatusRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.processDeviceCheckIns(iUpdateDeviceStatusRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update device status by ID (create if does not exist).
         * @param {string} id Unique ID of device.
         * @param {IUpdateDeviceStatusRequestDTO} [iUpdateDeviceStatusRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceStatusByID: function (id, iUpdateDeviceStatusRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDeviceStatusByID(id, iUpdateDeviceStatusRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DeviceStatusApiFp = DeviceStatusApiFp;
/**
 * DeviceStatusApi - factory interface
 * @export
 */
var DeviceStatusApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DeviceStatusApiFp)(configuration);
    return {
        /**
         * Get device status by ID.
         * @param {string} id Unique ID of device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceStatusByID: function (id, options) {
            return localVarFp.getDeviceStatusByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Process incoming device check ins (create if does not exist).
         * @param {Array<IUpdateDeviceStatusRequestDTO>} [iUpdateDeviceStatusRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processDeviceCheckIns: function (iUpdateDeviceStatusRequestDTO, options) {
            return localVarFp.processDeviceCheckIns(iUpdateDeviceStatusRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update device status by ID (create if does not exist).
         * @param {string} id Unique ID of device.
         * @param {IUpdateDeviceStatusRequestDTO} [iUpdateDeviceStatusRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeviceStatusByID: function (id, iUpdateDeviceStatusRequestDTO, options) {
            return localVarFp.updateDeviceStatusByID(id, iUpdateDeviceStatusRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DeviceStatusApiFactory = DeviceStatusApiFactory;
/**
 * DeviceStatusApi - object-oriented interface
 * @export
 * @class DeviceStatusApi
 * @extends {BaseAPI}
 */
var DeviceStatusApi = /** @class */ (function (_super) {
    __extends(DeviceStatusApi, _super);
    function DeviceStatusApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get device status by ID.
     * @param {string} id Unique ID of device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceStatusApi
     */
    DeviceStatusApi.prototype.getDeviceStatusByID = function (id, options) {
        var _this = this;
        return (0, exports.DeviceStatusApiFp)(this.configuration).getDeviceStatusByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Process incoming device check ins (create if does not exist).
     * @param {Array<IUpdateDeviceStatusRequestDTO>} [iUpdateDeviceStatusRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceStatusApi
     */
    DeviceStatusApi.prototype.processDeviceCheckIns = function (iUpdateDeviceStatusRequestDTO, options) {
        var _this = this;
        return (0, exports.DeviceStatusApiFp)(this.configuration).processDeviceCheckIns(iUpdateDeviceStatusRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update device status by ID (create if does not exist).
     * @param {string} id Unique ID of device.
     * @param {IUpdateDeviceStatusRequestDTO} [iUpdateDeviceStatusRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceStatusApi
     */
    DeviceStatusApi.prototype.updateDeviceStatusByID = function (id, iUpdateDeviceStatusRequestDTO, options) {
        var _this = this;
        return (0, exports.DeviceStatusApiFp)(this.configuration).updateDeviceStatusByID(id, iUpdateDeviceStatusRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DeviceStatusApi;
}(base_1.BaseAPI));
exports.DeviceStatusApi = DeviceStatusApi;
/**
 * FarmClusterApi - axios parameter creator
 * @export
 */
var FarmClusterApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Generate farm cluster by farm id.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateFarmClusterByFarmID: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('generateFarmClusterByFarmID', 'farmId', farmId);
                    localVarPath = "/tower/farm-cluster/generate/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.FarmClusterApiAxiosParamCreator = FarmClusterApiAxiosParamCreator;
/**
 * FarmClusterApi - functional programming interface
 * @export
 */
var FarmClusterApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FarmClusterApiAxiosParamCreator)(configuration);
    return {
        /**
         * Generate farm cluster by farm id.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateFarmClusterByFarmID: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.generateFarmClusterByFarmID(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FarmClusterApiFp = FarmClusterApiFp;
/**
 * FarmClusterApi - factory interface
 * @export
 */
var FarmClusterApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FarmClusterApiFp)(configuration);
    return {
        /**
         * Generate farm cluster by farm id.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateFarmClusterByFarmID: function (farmId, options) {
            return localVarFp.generateFarmClusterByFarmID(farmId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FarmClusterApiFactory = FarmClusterApiFactory;
/**
 * FarmClusterApi - object-oriented interface
 * @export
 * @class FarmClusterApi
 * @extends {BaseAPI}
 */
var FarmClusterApi = /** @class */ (function (_super) {
    __extends(FarmClusterApi, _super);
    function FarmClusterApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Generate farm cluster by farm id.
     * @param {string} farmId Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FarmClusterApi
     */
    FarmClusterApi.prototype.generateFarmClusterByFarmID = function (farmId, options) {
        var _this = this;
        return (0, exports.FarmClusterApiFp)(this.configuration).generateFarmClusterByFarmID(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FarmClusterApi;
}(base_1.BaseAPI));
exports.FarmClusterApi = FarmClusterApi;
/**
 * HealthCheckApi - axios parameter creator
 * @export
 */
var HealthCheckApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Check service health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkHealth: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/tower/health-check";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.HealthCheckApiAxiosParamCreator = HealthCheckApiAxiosParamCreator;
/**
 * HealthCheckApi - functional programming interface
 * @export
 */
var HealthCheckApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.HealthCheckApiAxiosParamCreator)(configuration);
    return {
        /**
         * Check service health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkHealth: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.checkHealth(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.HealthCheckApiFp = HealthCheckApiFp;
/**
 * HealthCheckApi - factory interface
 * @export
 */
var HealthCheckApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.HealthCheckApiFp)(configuration);
    return {
        /**
         * Check service health.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkHealth: function (options) {
            return localVarFp.checkHealth(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.HealthCheckApiFactory = HealthCheckApiFactory;
/**
 * HealthCheckApi - object-oriented interface
 * @export
 * @class HealthCheckApi
 * @extends {BaseAPI}
 */
var HealthCheckApi = /** @class */ (function (_super) {
    __extends(HealthCheckApi, _super);
    function HealthCheckApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Check service health.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    HealthCheckApi.prototype.checkHealth = function (options) {
        var _this = this;
        return (0, exports.HealthCheckApiFp)(this.configuration).checkHealth(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return HealthCheckApi;
}(base_1.BaseAPI));
exports.HealthCheckApi = HealthCheckApi;
/**
 * LoraCoverageApi - axios parameter creator
 * @export
 */
var LoraCoverageApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Clear keep alive until.
         * @param {string} gatewayId Unique ID of gateway.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearKeepAliveUntilByGatewayID: function (gatewayId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'gatewayId' is not null or undefined
                    (0, common_1.assertParamExists)('clearKeepAliveUntilByGatewayID', 'gatewayId', gatewayId);
                    localVarPath = "/tower/lora/coverage/selection/keep-alive/clear/{gatewayId}"
                        .replace("{".concat("gatewayId", "}"), encodeURIComponent(String(gatewayId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get lora coverage heat map by gateway ID.
         * @param {string} gatewayId Unique ID of gateway.
         * @param {number} [resolution] H3 geo index (heat map) resolution.
         * @param {number} [cursor] Cursor for heat map pagination.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoraCoverageHeatMapByGatewayID: function (gatewayId, resolution, cursor, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'gatewayId' is not null or undefined
                    (0, common_1.assertParamExists)('getLoraCoverageHeatMapByGatewayID', 'gatewayId', gatewayId);
                    localVarPath = "/tower/lora/coverage/heat-map/{gatewayId}"
                        .replace("{".concat("gatewayId", "}"), encodeURIComponent(String(gatewayId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (resolution !== undefined) {
                        localVarQueryParameter['resolution'] = resolution;
                    }
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get lora coverage selection by gateway ID.
         * @param {string} gatewayId Unique ID of gateway.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoraCoverageSelectionByGatewayID: function (gatewayId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'gatewayId' is not null or undefined
                    (0, common_1.assertParamExists)('getLoraCoverageSelectionByGatewayID', 'gatewayId', gatewayId);
                    localVarPath = "/tower/lora/coverage/selection/{gatewayId}"
                        .replace("{".concat("gatewayId", "}"), encodeURIComponent(String(gatewayId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Process incoming lora coverages.
         * @param {Array<IUpdateLoraCoverageRequestDTO>} [iUpdateLoraCoverageRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processLoraCoverages: function (iUpdateLoraCoverageRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/tower/lora/coverage";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateLoraCoverageRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Trigger lora coverage heat map aggregation by farm.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerLoraCoverageHeatMapAggregationByFarmID: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('triggerLoraCoverageHeatMapAggregationByFarmID', 'farmId', farmId);
                    localVarPath = "/tower/lora/coverage/heat-map/aggregation/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Trigger lora coverage selection aggregation by farm.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerLoraCoverageSelectionAggregationByFarmID: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('triggerLoraCoverageSelectionAggregationByFarmID', 'farmId', farmId);
                    localVarPath = "/tower/lora/coverage/selection/aggregation/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Insert or extend keep alive until. If gateway has current suspend until this will clear the suspend until.
         * @param {string} gatewayId Unique ID of gateway.
         * @param {number} keepAliveUntil Unix timestamp to keep alive until.
         * @param {IDeviceControlMethodEnum} method Method of device control
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKeepAliveUntilByGatewayID: function (gatewayId, keepAliveUntil, method, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'gatewayId' is not null or undefined
                    (0, common_1.assertParamExists)('updateKeepAliveUntilByGatewayID', 'gatewayId', gatewayId);
                    // verify required parameter 'keepAliveUntil' is not null or undefined
                    (0, common_1.assertParamExists)('updateKeepAliveUntilByGatewayID', 'keepAliveUntil', keepAliveUntil);
                    // verify required parameter 'method' is not null or undefined
                    (0, common_1.assertParamExists)('updateKeepAliveUntilByGatewayID', 'method', method);
                    localVarPath = "/tower/lora/coverage/selection/keep-alive/{gatewayId}/{keepAliveUntil}/{method}"
                        .replace("{".concat("gatewayId", "}"), encodeURIComponent(String(gatewayId)))
                        .replace("{".concat("keepAliveUntil", "}"), encodeURIComponent(String(keepAliveUntil)))
                        .replace("{".concat("method", "}"), encodeURIComponent(String(method)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Insert or extend suspend until. If gateway has current keep alive until this will do nothing.
         * @param {string} gatewayId Unique ID of gateway.
         * @param {number} suspendUntil Unix timestamp to suspend until.
         * @param {IDeviceControlMethodEnum} method Method of device control
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuspendUntilByGatewayID: function (gatewayId, suspendUntil, method, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'gatewayId' is not null or undefined
                    (0, common_1.assertParamExists)('updateSuspendUntilByGatewayID', 'gatewayId', gatewayId);
                    // verify required parameter 'suspendUntil' is not null or undefined
                    (0, common_1.assertParamExists)('updateSuspendUntilByGatewayID', 'suspendUntil', suspendUntil);
                    // verify required parameter 'method' is not null or undefined
                    (0, common_1.assertParamExists)('updateSuspendUntilByGatewayID', 'method', method);
                    localVarPath = "/tower/lora/coverage/selection/suspend/{gatewayId}/{suspendUntil}/{method}"
                        .replace("{".concat("gatewayId", "}"), encodeURIComponent(String(gatewayId)))
                        .replace("{".concat("suspendUntil", "}"), encodeURIComponent(String(suspendUntil)))
                        .replace("{".concat("method", "}"), encodeURIComponent(String(method)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.LoraCoverageApiAxiosParamCreator = LoraCoverageApiAxiosParamCreator;
/**
 * LoraCoverageApi - functional programming interface
 * @export
 */
var LoraCoverageApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LoraCoverageApiAxiosParamCreator)(configuration);
    return {
        /**
         * Clear keep alive until.
         * @param {string} gatewayId Unique ID of gateway.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearKeepAliveUntilByGatewayID: function (gatewayId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.clearKeepAliveUntilByGatewayID(gatewayId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get lora coverage heat map by gateway ID.
         * @param {string} gatewayId Unique ID of gateway.
         * @param {number} [resolution] H3 geo index (heat map) resolution.
         * @param {number} [cursor] Cursor for heat map pagination.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoraCoverageHeatMapByGatewayID: function (gatewayId, resolution, cursor, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLoraCoverageHeatMapByGatewayID(gatewayId, resolution, cursor, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get lora coverage selection by gateway ID.
         * @param {string} gatewayId Unique ID of gateway.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoraCoverageSelectionByGatewayID: function (gatewayId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLoraCoverageSelectionByGatewayID(gatewayId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Process incoming lora coverages.
         * @param {Array<IUpdateLoraCoverageRequestDTO>} [iUpdateLoraCoverageRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processLoraCoverages: function (iUpdateLoraCoverageRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.processLoraCoverages(iUpdateLoraCoverageRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Trigger lora coverage heat map aggregation by farm.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerLoraCoverageHeatMapAggregationByFarmID: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.triggerLoraCoverageHeatMapAggregationByFarmID(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Trigger lora coverage selection aggregation by farm.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerLoraCoverageSelectionAggregationByFarmID: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.triggerLoraCoverageSelectionAggregationByFarmID(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Insert or extend keep alive until. If gateway has current suspend until this will clear the suspend until.
         * @param {string} gatewayId Unique ID of gateway.
         * @param {number} keepAliveUntil Unix timestamp to keep alive until.
         * @param {IDeviceControlMethodEnum} method Method of device control
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKeepAliveUntilByGatewayID: function (gatewayId, keepAliveUntil, method, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateKeepAliveUntilByGatewayID(gatewayId, keepAliveUntil, method, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Insert or extend suspend until. If gateway has current keep alive until this will do nothing.
         * @param {string} gatewayId Unique ID of gateway.
         * @param {number} suspendUntil Unix timestamp to suspend until.
         * @param {IDeviceControlMethodEnum} method Method of device control
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuspendUntilByGatewayID: function (gatewayId, suspendUntil, method, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSuspendUntilByGatewayID(gatewayId, suspendUntil, method, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.LoraCoverageApiFp = LoraCoverageApiFp;
/**
 * LoraCoverageApi - factory interface
 * @export
 */
var LoraCoverageApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LoraCoverageApiFp)(configuration);
    return {
        /**
         * Clear keep alive until.
         * @param {string} gatewayId Unique ID of gateway.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearKeepAliveUntilByGatewayID: function (gatewayId, options) {
            return localVarFp.clearKeepAliveUntilByGatewayID(gatewayId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get lora coverage heat map by gateway ID.
         * @param {string} gatewayId Unique ID of gateway.
         * @param {number} [resolution] H3 geo index (heat map) resolution.
         * @param {number} [cursor] Cursor for heat map pagination.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoraCoverageHeatMapByGatewayID: function (gatewayId, resolution, cursor, options) {
            return localVarFp.getLoraCoverageHeatMapByGatewayID(gatewayId, resolution, cursor, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get lora coverage selection by gateway ID.
         * @param {string} gatewayId Unique ID of gateway.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoraCoverageSelectionByGatewayID: function (gatewayId, options) {
            return localVarFp.getLoraCoverageSelectionByGatewayID(gatewayId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Process incoming lora coverages.
         * @param {Array<IUpdateLoraCoverageRequestDTO>} [iUpdateLoraCoverageRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processLoraCoverages: function (iUpdateLoraCoverageRequestDTO, options) {
            return localVarFp.processLoraCoverages(iUpdateLoraCoverageRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Trigger lora coverage heat map aggregation by farm.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerLoraCoverageHeatMapAggregationByFarmID: function (farmId, options) {
            return localVarFp.triggerLoraCoverageHeatMapAggregationByFarmID(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Trigger lora coverage selection aggregation by farm.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerLoraCoverageSelectionAggregationByFarmID: function (farmId, options) {
            return localVarFp.triggerLoraCoverageSelectionAggregationByFarmID(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Insert or extend keep alive until. If gateway has current suspend until this will clear the suspend until.
         * @param {string} gatewayId Unique ID of gateway.
         * @param {number} keepAliveUntil Unix timestamp to keep alive until.
         * @param {IDeviceControlMethodEnum} method Method of device control
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateKeepAliveUntilByGatewayID: function (gatewayId, keepAliveUntil, method, options) {
            return localVarFp.updateKeepAliveUntilByGatewayID(gatewayId, keepAliveUntil, method, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Insert or extend suspend until. If gateway has current keep alive until this will do nothing.
         * @param {string} gatewayId Unique ID of gateway.
         * @param {number} suspendUntil Unix timestamp to suspend until.
         * @param {IDeviceControlMethodEnum} method Method of device control
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSuspendUntilByGatewayID: function (gatewayId, suspendUntil, method, options) {
            return localVarFp.updateSuspendUntilByGatewayID(gatewayId, suspendUntil, method, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LoraCoverageApiFactory = LoraCoverageApiFactory;
/**
 * LoraCoverageApi - object-oriented interface
 * @export
 * @class LoraCoverageApi
 * @extends {BaseAPI}
 */
var LoraCoverageApi = /** @class */ (function (_super) {
    __extends(LoraCoverageApi, _super);
    function LoraCoverageApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Clear keep alive until.
     * @param {string} gatewayId Unique ID of gateway.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoraCoverageApi
     */
    LoraCoverageApi.prototype.clearKeepAliveUntilByGatewayID = function (gatewayId, options) {
        var _this = this;
        return (0, exports.LoraCoverageApiFp)(this.configuration).clearKeepAliveUntilByGatewayID(gatewayId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get lora coverage heat map by gateway ID.
     * @param {string} gatewayId Unique ID of gateway.
     * @param {number} [resolution] H3 geo index (heat map) resolution.
     * @param {number} [cursor] Cursor for heat map pagination.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoraCoverageApi
     */
    LoraCoverageApi.prototype.getLoraCoverageHeatMapByGatewayID = function (gatewayId, resolution, cursor, options) {
        var _this = this;
        return (0, exports.LoraCoverageApiFp)(this.configuration).getLoraCoverageHeatMapByGatewayID(gatewayId, resolution, cursor, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get lora coverage selection by gateway ID.
     * @param {string} gatewayId Unique ID of gateway.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoraCoverageApi
     */
    LoraCoverageApi.prototype.getLoraCoverageSelectionByGatewayID = function (gatewayId, options) {
        var _this = this;
        return (0, exports.LoraCoverageApiFp)(this.configuration).getLoraCoverageSelectionByGatewayID(gatewayId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Process incoming lora coverages.
     * @param {Array<IUpdateLoraCoverageRequestDTO>} [iUpdateLoraCoverageRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoraCoverageApi
     */
    LoraCoverageApi.prototype.processLoraCoverages = function (iUpdateLoraCoverageRequestDTO, options) {
        var _this = this;
        return (0, exports.LoraCoverageApiFp)(this.configuration).processLoraCoverages(iUpdateLoraCoverageRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Trigger lora coverage heat map aggregation by farm.
     * @param {string} farmId Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoraCoverageApi
     */
    LoraCoverageApi.prototype.triggerLoraCoverageHeatMapAggregationByFarmID = function (farmId, options) {
        var _this = this;
        return (0, exports.LoraCoverageApiFp)(this.configuration).triggerLoraCoverageHeatMapAggregationByFarmID(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Trigger lora coverage selection aggregation by farm.
     * @param {string} farmId Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoraCoverageApi
     */
    LoraCoverageApi.prototype.triggerLoraCoverageSelectionAggregationByFarmID = function (farmId, options) {
        var _this = this;
        return (0, exports.LoraCoverageApiFp)(this.configuration).triggerLoraCoverageSelectionAggregationByFarmID(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Insert or extend keep alive until. If gateway has current suspend until this will clear the suspend until.
     * @param {string} gatewayId Unique ID of gateway.
     * @param {number} keepAliveUntil Unix timestamp to keep alive until.
     * @param {IDeviceControlMethodEnum} method Method of device control
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoraCoverageApi
     */
    LoraCoverageApi.prototype.updateKeepAliveUntilByGatewayID = function (gatewayId, keepAliveUntil, method, options) {
        var _this = this;
        return (0, exports.LoraCoverageApiFp)(this.configuration).updateKeepAliveUntilByGatewayID(gatewayId, keepAliveUntil, method, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Insert or extend suspend until. If gateway has current keep alive until this will do nothing.
     * @param {string} gatewayId Unique ID of gateway.
     * @param {number} suspendUntil Unix timestamp to suspend until.
     * @param {IDeviceControlMethodEnum} method Method of device control
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoraCoverageApi
     */
    LoraCoverageApi.prototype.updateSuspendUntilByGatewayID = function (gatewayId, suspendUntil, method, options) {
        var _this = this;
        return (0, exports.LoraCoverageApiFp)(this.configuration).updateSuspendUntilByGatewayID(gatewayId, suspendUntil, method, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LoraCoverageApi;
}(base_1.BaseAPI));
exports.LoraCoverageApi = LoraCoverageApi;
/**
 * NetworkDeviceContextApi - axios parameter creator
 * @export
 */
var NetworkDeviceContextApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create network device context.
         * @param {ICreateNetworkDeviceContextRequestDTO} [iCreateNetworkDeviceContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNetworkDeviceContext: function (iCreateNetworkDeviceContextRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/tower/network-device-context";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateNetworkDeviceContextRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete network device context by ID.
         * @param {string} id Unique ID of network device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNetworkDeviceContextByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteNetworkDeviceContextByID', 'id', id);
                    localVarPath = "/tower/network-device-context/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all network device contexts.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkDeviceContexts: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/tower/network-device-context";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all network device contexts by shard id.
         * @param {string} shardId Unique ID of shard.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkDeviceContextsByShardID: function (shardId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'shardId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllNetworkDeviceContextsByShardID', 'shardId', shardId);
                    localVarPath = "/tower/network-device-context/shard/{shardId}"
                        .replace("{".concat("shardId", "}"), encodeURIComponent(String(shardId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all network device contexts by tower id.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkDeviceContextsByTowerID: function (towerId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'towerId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllNetworkDeviceContextsByTowerID', 'towerId', towerId);
                    localVarPath = "/tower/network-device-context/tower/{towerId}"
                        .replace("{".concat("towerId", "}"), encodeURIComponent(String(towerId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get network device context by ID.
         * @param {string} id Unique ID of network device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkDeviceContextByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getNetworkDeviceContextByID', 'id', id);
                    localVarPath = "/tower/network-device-context/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update network device context by ID.
         * @param {string} id Unique ID of network device.
         * @param {IUpdateNetworkDeviceContextRequestDTO} [iUpdateNetworkDeviceContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNetworkDeviceContextByID: function (id, iUpdateNetworkDeviceContextRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateNetworkDeviceContextByID', 'id', id);
                    localVarPath = "/tower/network-device-context/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateNetworkDeviceContextRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.NetworkDeviceContextApiAxiosParamCreator = NetworkDeviceContextApiAxiosParamCreator;
/**
 * NetworkDeviceContextApi - functional programming interface
 * @export
 */
var NetworkDeviceContextApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.NetworkDeviceContextApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create network device context.
         * @param {ICreateNetworkDeviceContextRequestDTO} [iCreateNetworkDeviceContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNetworkDeviceContext: function (iCreateNetworkDeviceContextRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createNetworkDeviceContext(iCreateNetworkDeviceContextRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete network device context by ID.
         * @param {string} id Unique ID of network device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNetworkDeviceContextByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteNetworkDeviceContextByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all network device contexts.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkDeviceContexts: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllNetworkDeviceContexts(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all network device contexts by shard id.
         * @param {string} shardId Unique ID of shard.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkDeviceContextsByShardID: function (shardId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllNetworkDeviceContextsByShardID(shardId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all network device contexts by tower id.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkDeviceContextsByTowerID: function (towerId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllNetworkDeviceContextsByTowerID(towerId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get network device context by ID.
         * @param {string} id Unique ID of network device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkDeviceContextByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getNetworkDeviceContextByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update network device context by ID.
         * @param {string} id Unique ID of network device.
         * @param {IUpdateNetworkDeviceContextRequestDTO} [iUpdateNetworkDeviceContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNetworkDeviceContextByID: function (id, iUpdateNetworkDeviceContextRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateNetworkDeviceContextByID(id, iUpdateNetworkDeviceContextRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.NetworkDeviceContextApiFp = NetworkDeviceContextApiFp;
/**
 * NetworkDeviceContextApi - factory interface
 * @export
 */
var NetworkDeviceContextApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.NetworkDeviceContextApiFp)(configuration);
    return {
        /**
         * Create network device context.
         * @param {ICreateNetworkDeviceContextRequestDTO} [iCreateNetworkDeviceContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNetworkDeviceContext: function (iCreateNetworkDeviceContextRequestDTO, options) {
            return localVarFp.createNetworkDeviceContext(iCreateNetworkDeviceContextRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete network device context by ID.
         * @param {string} id Unique ID of network device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNetworkDeviceContextByID: function (id, options) {
            return localVarFp.deleteNetworkDeviceContextByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all network device contexts.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkDeviceContexts: function (options) {
            return localVarFp.getAllNetworkDeviceContexts(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all network device contexts by shard id.
         * @param {string} shardId Unique ID of shard.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkDeviceContextsByShardID: function (shardId, options) {
            return localVarFp.getAllNetworkDeviceContextsByShardID(shardId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all network device contexts by tower id.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNetworkDeviceContextsByTowerID: function (towerId, options) {
            return localVarFp.getAllNetworkDeviceContextsByTowerID(towerId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get network device context by ID.
         * @param {string} id Unique ID of network device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNetworkDeviceContextByID: function (id, options) {
            return localVarFp.getNetworkDeviceContextByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update network device context by ID.
         * @param {string} id Unique ID of network device.
         * @param {IUpdateNetworkDeviceContextRequestDTO} [iUpdateNetworkDeviceContextRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNetworkDeviceContextByID: function (id, iUpdateNetworkDeviceContextRequestDTO, options) {
            return localVarFp.updateNetworkDeviceContextByID(id, iUpdateNetworkDeviceContextRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.NetworkDeviceContextApiFactory = NetworkDeviceContextApiFactory;
/**
 * NetworkDeviceContextApi - object-oriented interface
 * @export
 * @class NetworkDeviceContextApi
 * @extends {BaseAPI}
 */
var NetworkDeviceContextApi = /** @class */ (function (_super) {
    __extends(NetworkDeviceContextApi, _super);
    function NetworkDeviceContextApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create network device context.
     * @param {ICreateNetworkDeviceContextRequestDTO} [iCreateNetworkDeviceContextRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkDeviceContextApi
     */
    NetworkDeviceContextApi.prototype.createNetworkDeviceContext = function (iCreateNetworkDeviceContextRequestDTO, options) {
        var _this = this;
        return (0, exports.NetworkDeviceContextApiFp)(this.configuration).createNetworkDeviceContext(iCreateNetworkDeviceContextRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete network device context by ID.
     * @param {string} id Unique ID of network device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkDeviceContextApi
     */
    NetworkDeviceContextApi.prototype.deleteNetworkDeviceContextByID = function (id, options) {
        var _this = this;
        return (0, exports.NetworkDeviceContextApiFp)(this.configuration).deleteNetworkDeviceContextByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all network device contexts.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkDeviceContextApi
     */
    NetworkDeviceContextApi.prototype.getAllNetworkDeviceContexts = function (options) {
        var _this = this;
        return (0, exports.NetworkDeviceContextApiFp)(this.configuration).getAllNetworkDeviceContexts(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all network device contexts by shard id.
     * @param {string} shardId Unique ID of shard.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkDeviceContextApi
     */
    NetworkDeviceContextApi.prototype.getAllNetworkDeviceContextsByShardID = function (shardId, options) {
        var _this = this;
        return (0, exports.NetworkDeviceContextApiFp)(this.configuration).getAllNetworkDeviceContextsByShardID(shardId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all network device contexts by tower id.
     * @param {string} towerId Unique ID of tower.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkDeviceContextApi
     */
    NetworkDeviceContextApi.prototype.getAllNetworkDeviceContextsByTowerID = function (towerId, options) {
        var _this = this;
        return (0, exports.NetworkDeviceContextApiFp)(this.configuration).getAllNetworkDeviceContextsByTowerID(towerId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get network device context by ID.
     * @param {string} id Unique ID of network device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkDeviceContextApi
     */
    NetworkDeviceContextApi.prototype.getNetworkDeviceContextByID = function (id, options) {
        var _this = this;
        return (0, exports.NetworkDeviceContextApiFp)(this.configuration).getNetworkDeviceContextByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update network device context by ID.
     * @param {string} id Unique ID of network device.
     * @param {IUpdateNetworkDeviceContextRequestDTO} [iUpdateNetworkDeviceContextRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NetworkDeviceContextApi
     */
    NetworkDeviceContextApi.prototype.updateNetworkDeviceContextByID = function (id, iUpdateNetworkDeviceContextRequestDTO, options) {
        var _this = this;
        return (0, exports.NetworkDeviceContextApiFp)(this.configuration).updateNetworkDeviceContextByID(id, iUpdateNetworkDeviceContextRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return NetworkDeviceContextApi;
}(base_1.BaseAPI));
exports.NetworkDeviceContextApi = NetworkDeviceContextApi;
/**
 * TowerApi - axios parameter creator
 * @export
 */
var TowerApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create tower.
         * @param {ICreateTowerRequestDTO} [iCreateTowerRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTower: function (iCreateTowerRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/tower/tower";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateTowerRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Create tower farm mapping.
         * @param {ICreateTowerFarmMappingDTO} [iCreateTowerFarmMappingDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTowerFarmMapping: function (iCreateTowerFarmMappingDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/tower/tower/mapping";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateTowerFarmMappingDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Create tower network group mapping.
         * @param {ICreateTowerNetworkGroupMappingDTO} [iCreateTowerNetworkGroupMappingDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTowerNetworkGroupMapping: function (iCreateTowerNetworkGroupMappingDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/tower/tower/mapping/network-group";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateTowerNetworkGroupMappingDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Create tower note.
         * @param {ICreateTowerNoteRequestDTO} [iCreateTowerNoteRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTowerNote: function (iCreateTowerNoteRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/tower/tower/note";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCreateTowerNoteRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete tower by ID.
         * @param {string} id Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTowerByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteTowerByID', 'id', id);
                    localVarPath = "/tower/tower/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete tower farm mapping by tower id and farm id.
         * @param {string} farmId Unique ID of farm.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTowerFarmMappingByFarmIDAndTowerID: function (farmId, towerId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteTowerFarmMappingByFarmIDAndTowerID', 'farmId', farmId);
                    // verify required parameter 'towerId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteTowerFarmMappingByFarmIDAndTowerID', 'towerId', towerId);
                    localVarPath = "/tower/tower/mapping/{farmId}/{towerId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)))
                        .replace("{".concat("towerId", "}"), encodeURIComponent(String(towerId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Delete tower note by tower ID and created at.
         * @param {string} id Unique ID of tower.
         * @param {number} createdAt Timestamp of tower note creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTowerNoteByTowerIDAndCreatedAt: function (id, createdAt, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('deleteTowerNoteByTowerIDAndCreatedAt', 'id', id);
                    // verify required parameter 'createdAt' is not null or undefined
                    (0, common_1.assertParamExists)('deleteTowerNoteByTowerIDAndCreatedAt', 'createdAt', createdAt);
                    localVarPath = "/tower/tower/note/{id}/{createdAt}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                        .replace("{".concat("createdAt", "}"), encodeURIComponent(String(createdAt)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all tower farm mappings by tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowerFarmMappingsByTowerID: function (towerId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'towerId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllTowerFarmMappingsByTowerID', 'towerId', towerId);
                    localVarPath = "/tower/tower/mapping/{towerId}"
                        .replace("{".concat("towerId", "}"), encodeURIComponent(String(towerId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all tower notes by tower ID.
         * @param {string} id Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowerNotesByTowerID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getAllTowerNotesByTowerID', 'id', id);
                    localVarPath = "/tower/tower/note/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all towers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowers: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/tower/tower";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all towers by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowersByFarmID: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllTowersByFarmID', 'farmId', farmId);
                    localVarPath = "/tower/tower/farm/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all towers by network group ID.
         * @param {string} networkGroupId Unique ID of network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowersByNetworkGroupID: function (networkGroupId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'networkGroupId' is not null or undefined
                    (0, common_1.assertParamExists)('getAllTowersByNetworkGroupID', 'networkGroupId', networkGroupId);
                    localVarPath = "/tower/tower/network-group/{networkGroupId}"
                        .replace("{".concat("networkGroupId", "}"), encodeURIComponent(String(networkGroupId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all towers within the specified radius from specified latitude longitue coordinate.
         * @param {number} [latitude] Latitude to search.
         * @param {number} [longitude] Longitude to search.
         * @param {number} [radius] Radius to search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowersByRadiusAndLatLng: function (latitude, longitude, radius, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/tower/tower/location";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (latitude !== undefined) {
                        localVarQueryParameter['latitude'] = latitude;
                    }
                    if (longitude !== undefined) {
                        localVarQueryParameter['longitude'] = longitude;
                    }
                    if (radius !== undefined) {
                        localVarQueryParameter['radius'] = radius;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get tower by ID.
         * @param {string} id Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTowerByID: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getTowerByID', 'id', id);
                    localVarPath = "/tower/tower/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get tower network group mapping by tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTowerNetworkGroupMappingByTowerID: function (towerId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'towerId' is not null or undefined
                    (0, common_1.assertParamExists)('getTowerNetworkGroupMappingByTowerID', 'towerId', towerId);
                    localVarPath = "/tower/tower/mapping/network-group/{towerId}"
                        .replace("{".concat("towerId", "}"), encodeURIComponent(String(towerId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Sync tower geo locations.
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncTowerGeoLocations: function (requestBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/tower/tower/geo-location";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update tower by ID.
         * @param {string} id Unique ID of tower.
         * @param {IUpdateTowerRequestDTO} [iUpdateTowerRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTowerByID: function (id, iUpdateTowerRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateTowerByID', 'id', id);
                    localVarPath = "/tower/tower/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateTowerRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update tower note by tower ID and created at.
         * @param {string} id Unique ID of tower.
         * @param {number} createdAt Timestamp of tower note creation.
         * @param {IUpdateTowerNoteRequestDTO} [iUpdateTowerNoteRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTowerNoteByTowerIDAndCreatedAt: function (id, createdAt, iUpdateTowerNoteRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateTowerNoteByTowerIDAndCreatedAt', 'id', id);
                    // verify required parameter 'createdAt' is not null or undefined
                    (0, common_1.assertParamExists)('updateTowerNoteByTowerIDAndCreatedAt', 'createdAt', createdAt);
                    localVarPath = "/tower/tower/note/{id}/{createdAt}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                        .replace("{".concat("createdAt", "}"), encodeURIComponent(String(createdAt)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpdateTowerNoteRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.TowerApiAxiosParamCreator = TowerApiAxiosParamCreator;
/**
 * TowerApi - functional programming interface
 * @export
 */
var TowerApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TowerApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create tower.
         * @param {ICreateTowerRequestDTO} [iCreateTowerRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTower: function (iCreateTowerRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createTower(iCreateTowerRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create tower farm mapping.
         * @param {ICreateTowerFarmMappingDTO} [iCreateTowerFarmMappingDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTowerFarmMapping: function (iCreateTowerFarmMappingDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createTowerFarmMapping(iCreateTowerFarmMappingDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create tower network group mapping.
         * @param {ICreateTowerNetworkGroupMappingDTO} [iCreateTowerNetworkGroupMappingDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTowerNetworkGroupMapping: function (iCreateTowerNetworkGroupMappingDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createTowerNetworkGroupMapping(iCreateTowerNetworkGroupMappingDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create tower note.
         * @param {ICreateTowerNoteRequestDTO} [iCreateTowerNoteRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTowerNote: function (iCreateTowerNoteRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createTowerNote(iCreateTowerNoteRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete tower by ID.
         * @param {string} id Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTowerByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteTowerByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete tower farm mapping by tower id and farm id.
         * @param {string} farmId Unique ID of farm.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTowerFarmMappingByFarmIDAndTowerID: function (farmId, towerId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteTowerFarmMappingByFarmIDAndTowerID(farmId, towerId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete tower note by tower ID and created at.
         * @param {string} id Unique ID of tower.
         * @param {number} createdAt Timestamp of tower note creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTowerNoteByTowerIDAndCreatedAt: function (id, createdAt, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteTowerNoteByTowerIDAndCreatedAt(id, createdAt, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all tower farm mappings by tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowerFarmMappingsByTowerID: function (towerId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllTowerFarmMappingsByTowerID(towerId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all tower notes by tower ID.
         * @param {string} id Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowerNotesByTowerID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllTowerNotesByTowerID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all towers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowers: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllTowers(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all towers by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowersByFarmID: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllTowersByFarmID(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all towers by network group ID.
         * @param {string} networkGroupId Unique ID of network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowersByNetworkGroupID: function (networkGroupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllTowersByNetworkGroupID(networkGroupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all towers within the specified radius from specified latitude longitue coordinate.
         * @param {number} [latitude] Latitude to search.
         * @param {number} [longitude] Longitude to search.
         * @param {number} [radius] Radius to search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowersByRadiusAndLatLng: function (latitude, longitude, radius, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllTowersByRadiusAndLatLng(latitude, longitude, radius, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get tower by ID.
         * @param {string} id Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTowerByID: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTowerByID(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get tower network group mapping by tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTowerNetworkGroupMappingByTowerID: function (towerId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTowerNetworkGroupMappingByTowerID(towerId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Sync tower geo locations.
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncTowerGeoLocations: function (requestBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.syncTowerGeoLocations(requestBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update tower by ID.
         * @param {string} id Unique ID of tower.
         * @param {IUpdateTowerRequestDTO} [iUpdateTowerRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTowerByID: function (id, iUpdateTowerRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateTowerByID(id, iUpdateTowerRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update tower note by tower ID and created at.
         * @param {string} id Unique ID of tower.
         * @param {number} createdAt Timestamp of tower note creation.
         * @param {IUpdateTowerNoteRequestDTO} [iUpdateTowerNoteRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTowerNoteByTowerIDAndCreatedAt: function (id, createdAt, iUpdateTowerNoteRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateTowerNoteByTowerIDAndCreatedAt(id, createdAt, iUpdateTowerNoteRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TowerApiFp = TowerApiFp;
/**
 * TowerApi - factory interface
 * @export
 */
var TowerApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TowerApiFp)(configuration);
    return {
        /**
         * Create tower.
         * @param {ICreateTowerRequestDTO} [iCreateTowerRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTower: function (iCreateTowerRequestDTO, options) {
            return localVarFp.createTower(iCreateTowerRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create tower farm mapping.
         * @param {ICreateTowerFarmMappingDTO} [iCreateTowerFarmMappingDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTowerFarmMapping: function (iCreateTowerFarmMappingDTO, options) {
            return localVarFp.createTowerFarmMapping(iCreateTowerFarmMappingDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create tower network group mapping.
         * @param {ICreateTowerNetworkGroupMappingDTO} [iCreateTowerNetworkGroupMappingDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTowerNetworkGroupMapping: function (iCreateTowerNetworkGroupMappingDTO, options) {
            return localVarFp.createTowerNetworkGroupMapping(iCreateTowerNetworkGroupMappingDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create tower note.
         * @param {ICreateTowerNoteRequestDTO} [iCreateTowerNoteRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTowerNote: function (iCreateTowerNoteRequestDTO, options) {
            return localVarFp.createTowerNote(iCreateTowerNoteRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete tower by ID.
         * @param {string} id Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTowerByID: function (id, options) {
            return localVarFp.deleteTowerByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete tower farm mapping by tower id and farm id.
         * @param {string} farmId Unique ID of farm.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTowerFarmMappingByFarmIDAndTowerID: function (farmId, towerId, options) {
            return localVarFp.deleteTowerFarmMappingByFarmIDAndTowerID(farmId, towerId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete tower note by tower ID and created at.
         * @param {string} id Unique ID of tower.
         * @param {number} createdAt Timestamp of tower note creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTowerNoteByTowerIDAndCreatedAt: function (id, createdAt, options) {
            return localVarFp.deleteTowerNoteByTowerIDAndCreatedAt(id, createdAt, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all tower farm mappings by tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowerFarmMappingsByTowerID: function (towerId, options) {
            return localVarFp.getAllTowerFarmMappingsByTowerID(towerId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all tower notes by tower ID.
         * @param {string} id Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowerNotesByTowerID: function (id, options) {
            return localVarFp.getAllTowerNotesByTowerID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all towers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowers: function (options) {
            return localVarFp.getAllTowers(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all towers by farm ID.
         * @param {string} farmId Unique ID of farm.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowersByFarmID: function (farmId, options) {
            return localVarFp.getAllTowersByFarmID(farmId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all towers by network group ID.
         * @param {string} networkGroupId Unique ID of network group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowersByNetworkGroupID: function (networkGroupId, options) {
            return localVarFp.getAllTowersByNetworkGroupID(networkGroupId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all towers within the specified radius from specified latitude longitue coordinate.
         * @param {number} [latitude] Latitude to search.
         * @param {number} [longitude] Longitude to search.
         * @param {number} [radius] Radius to search.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTowersByRadiusAndLatLng: function (latitude, longitude, radius, options) {
            return localVarFp.getAllTowersByRadiusAndLatLng(latitude, longitude, radius, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get tower by ID.
         * @param {string} id Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTowerByID: function (id, options) {
            return localVarFp.getTowerByID(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get tower network group mapping by tower ID.
         * @param {string} towerId Unique ID of tower.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTowerNetworkGroupMappingByTowerID: function (towerId, options) {
            return localVarFp.getTowerNetworkGroupMappingByTowerID(towerId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Sync tower geo locations.
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncTowerGeoLocations: function (requestBody, options) {
            return localVarFp.syncTowerGeoLocations(requestBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update tower by ID.
         * @param {string} id Unique ID of tower.
         * @param {IUpdateTowerRequestDTO} [iUpdateTowerRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTowerByID: function (id, iUpdateTowerRequestDTO, options) {
            return localVarFp.updateTowerByID(id, iUpdateTowerRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update tower note by tower ID and created at.
         * @param {string} id Unique ID of tower.
         * @param {number} createdAt Timestamp of tower note creation.
         * @param {IUpdateTowerNoteRequestDTO} [iUpdateTowerNoteRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTowerNoteByTowerIDAndCreatedAt: function (id, createdAt, iUpdateTowerNoteRequestDTO, options) {
            return localVarFp.updateTowerNoteByTowerIDAndCreatedAt(id, createdAt, iUpdateTowerNoteRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TowerApiFactory = TowerApiFactory;
/**
 * TowerApi - object-oriented interface
 * @export
 * @class TowerApi
 * @extends {BaseAPI}
 */
var TowerApi = /** @class */ (function (_super) {
    __extends(TowerApi, _super);
    function TowerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create tower.
     * @param {ICreateTowerRequestDTO} [iCreateTowerRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.createTower = function (iCreateTowerRequestDTO, options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).createTower(iCreateTowerRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create tower farm mapping.
     * @param {ICreateTowerFarmMappingDTO} [iCreateTowerFarmMappingDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.createTowerFarmMapping = function (iCreateTowerFarmMappingDTO, options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).createTowerFarmMapping(iCreateTowerFarmMappingDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create tower network group mapping.
     * @param {ICreateTowerNetworkGroupMappingDTO} [iCreateTowerNetworkGroupMappingDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.createTowerNetworkGroupMapping = function (iCreateTowerNetworkGroupMappingDTO, options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).createTowerNetworkGroupMapping(iCreateTowerNetworkGroupMappingDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create tower note.
     * @param {ICreateTowerNoteRequestDTO} [iCreateTowerNoteRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.createTowerNote = function (iCreateTowerNoteRequestDTO, options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).createTowerNote(iCreateTowerNoteRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete tower by ID.
     * @param {string} id Unique ID of tower.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.deleteTowerByID = function (id, options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).deleteTowerByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete tower farm mapping by tower id and farm id.
     * @param {string} farmId Unique ID of farm.
     * @param {string} towerId Unique ID of tower.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.deleteTowerFarmMappingByFarmIDAndTowerID = function (farmId, towerId, options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).deleteTowerFarmMappingByFarmIDAndTowerID(farmId, towerId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete tower note by tower ID and created at.
     * @param {string} id Unique ID of tower.
     * @param {number} createdAt Timestamp of tower note creation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.deleteTowerNoteByTowerIDAndCreatedAt = function (id, createdAt, options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).deleteTowerNoteByTowerIDAndCreatedAt(id, createdAt, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all tower farm mappings by tower ID.
     * @param {string} towerId Unique ID of tower.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.getAllTowerFarmMappingsByTowerID = function (towerId, options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).getAllTowerFarmMappingsByTowerID(towerId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all tower notes by tower ID.
     * @param {string} id Unique ID of tower.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.getAllTowerNotesByTowerID = function (id, options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).getAllTowerNotesByTowerID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all towers.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.getAllTowers = function (options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).getAllTowers(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all towers by farm ID.
     * @param {string} farmId Unique ID of farm.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.getAllTowersByFarmID = function (farmId, options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).getAllTowersByFarmID(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all towers by network group ID.
     * @param {string} networkGroupId Unique ID of network group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.getAllTowersByNetworkGroupID = function (networkGroupId, options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).getAllTowersByNetworkGroupID(networkGroupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all towers within the specified radius from specified latitude longitue coordinate.
     * @param {number} [latitude] Latitude to search.
     * @param {number} [longitude] Longitude to search.
     * @param {number} [radius] Radius to search.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.getAllTowersByRadiusAndLatLng = function (latitude, longitude, radius, options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).getAllTowersByRadiusAndLatLng(latitude, longitude, radius, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get tower by ID.
     * @param {string} id Unique ID of tower.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.getTowerByID = function (id, options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).getTowerByID(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get tower network group mapping by tower ID.
     * @param {string} towerId Unique ID of tower.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.getTowerNetworkGroupMappingByTowerID = function (towerId, options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).getTowerNetworkGroupMappingByTowerID(towerId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Sync tower geo locations.
     * @param {Array<string>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.syncTowerGeoLocations = function (requestBody, options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).syncTowerGeoLocations(requestBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update tower by ID.
     * @param {string} id Unique ID of tower.
     * @param {IUpdateTowerRequestDTO} [iUpdateTowerRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.updateTowerByID = function (id, iUpdateTowerRequestDTO, options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).updateTowerByID(id, iUpdateTowerRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update tower note by tower ID and created at.
     * @param {string} id Unique ID of tower.
     * @param {number} createdAt Timestamp of tower note creation.
     * @param {IUpdateTowerNoteRequestDTO} [iUpdateTowerNoteRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TowerApi
     */
    TowerApi.prototype.updateTowerNoteByTowerIDAndCreatedAt = function (id, createdAt, iUpdateTowerNoteRequestDTO, options) {
        var _this = this;
        return (0, exports.TowerApiFp)(this.configuration).updateTowerNoteByTowerIDAndCreatedAt(id, createdAt, iUpdateTowerNoteRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TowerApi;
}(base_1.BaseAPI));
exports.TowerApi = TowerApi;
